(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('containerExpand', function () {
			return {
				restrict: 'C',
				scope: {
					containerExpand: '='
				},
				link: function (scope, el, attrs) {
					var header = $(el).find(".link-expand");
					var content = $(el).find(".section-expand");

					//convert string to boolean
					var isContentVisible = false;

					angular.element(document).ready(function () {
						if (isContentVisible) {
							content.slideDown();
							$(el).addClass("expanded");
							header.attr("aria-expanded", 'true').removeClass("collapsed").addClass("expanded");
							$(el).find('.link-expand .collapsed').hide()
							$(el).find('.link-expand .expanded').show()
						}
						else {
							content.slideUp();
							$(el).removeClass("expanded");
							header.attr("aria-expanded", 'false').removeClass("expanded").addClass("collapsed");
							$(el).find('.link-expand .collapsed').show()
							$(el).find('.link-expand .expanded').hide()
							scope.$eval(attrs.onExpand);
						}

						header.mousedown(function () {
							header.css("outline", "0")
						})

						header.blur(function () {
							header.css("outline", "")
						})

						// click event covers enter key
						header.click(function () {
							if (isContentVisible) {
								content.slideUp();
								$(el).removeClass("expanded");
								isContentVisible = false;
								header.attr("aria-expanded", 'false').toggleClass("expanded collapsed");
								$(el).find('.link-expand .collapsed').show()
								$(el).find('.link-expand .expanded').hide()
							}
							else {
								content.slideDown();
								$(el).addClass("expanded");
								isContentVisible = true;
								header.attr("aria-expanded", 'true').toggleClass("expanded collapsed");
								$(el).find('.link-expand .collapsed').hide()
								$(el).find('.link-expand .expanded').show()
								scope.$eval(attrs.onExpand);
							}
						});
					});
				}
			}
		});

})();
